// TODO: Move all TrialStatus related enums to a central location
export enum TrialLinkStatus {
  REDEEMED = 'redeemed',
  LINKEXPIRED = 'linkexpired',
  UNREDEEMED = 'unredeemed',
  CANCELLED = 'cancelled',
  TRIALEXPIRED = 'expired',
}

export enum TrialStatus {
  ACTIVE = 'Active',
  PROVISIONING = 'Provisioning',
  ENDED = 'Ended',
}

export enum UserAssignedTrialStatus {
  ACTIVE = 'Active',
  EXPIRED = 'Expired',
}
